import StudentBaseModel from "./StudentBaseModel";
import TutorModel from "./TutorModel";

export default class StudentModel extends StudentBaseModel {
  tutor?: TutorModel | null;

  constructor(arg: any) {
    super(arg);
    if (!!arg.tutor) this.tutor = TutorModel.fromApiResponse(arg.tutor);
  }

  get is_scheduled() {
    return !!this.tutor;
  }
}
